import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { useLenis, ScrollToTop } from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => {
  useLenis();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollToTop />
      <Header />
      <CartDrawer />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: { background: "#000", color: "#fff", border: "none", borderRadius: "9999px", padding: "12px 22px" },
        }}
      />
    </div>
  );
};
